module.exports = __webpack_public_path__ + "img/antony.2121fd00.webp";